module.exports = __webpack_public_path__ + "30eaccdfec263b391f49f37392a93018.svg";